import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'


class TokenLogin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      modal: false,
      token: '',
      isTokenError: false,
      inactiveError: false,
     
    }
    this.checkForErrors = this.checkForErrors.bind(this)

  }

  checkForErrors(values){
    return false;
  }

  componentDidMount(){
    let param = this.props.location.search
    let paramSplit = param.split('&userid=')
      
    let tokenParam = paramSplit[0].split('=')

    let token = tokenParam[1]

    let apiInput
    if(paramSplit[1] === undefined){  
      apiInput = {
        'token': token
      }
    }

    else{
      apiInput = {
        'token': token,
        'userid': paramSplit[1]
      } 
    }


    const obj = {}
    api
        .tokenLogin(apiInput)
        .then((result) => {
          console.log(result)
          const { status, data, errors } = result
          if (status === 'error') {
            this.setState({ isTokenError: true })
          }
          if (status === 'success') {
            //console.log('inside success')
            this.setState({ errorMsg: '' })
            obj.accessToken = result.headers.accessToken            
            //console.log('after setting header')
            obj.userName = data.userName
            obj.id = data.id
            obj.role = data.role
            this.props.userLogin(obj)
            this.props.history.push('/portal/app/my_registrations')
          }
          if(status === 'inactivate'){
            this.setState({ inactiveError: true })
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Login. Please contact Admin' })
        })
  }

  render() {

    let tokenErrorMsg,inactiveErrorMsg
    if(this.state.isTokenError){
      tokenErrorMsg =(<div>
        <p>Please enter your email address <a href="https://centa.org/portal/forgot_password">here</a> for us to send you the link to login to your account.  In case you are facing any issues, please WhatsApp us on +91 73496 62401 or email us on team@centa.org.</p>
        <br />
        <p>In case you are accessing through a mobile phone, please click here: <a href="https://m.centa.org/">m.centa.org</a></p>
      </div>)
    }
    if(this.state.inactiveError){
      inactiveErrorMsg =(<div>
        <p>You are not veified with mobile number. Please contact Admin</p>
        <br />
        <p>In case you are accessing through a mobile phone, please click here: <a href="https://m.centa.org/">m.centa.org</a></p>
      </div>)
    }
    return (
      <div>
        <Grid className="login-card">
          <GridCell span="4" align="middle"></GridCell>
          <GridCell className="align-center" span="4">
            <form onSubmit={this.handleSubmit}>
              <Card style={{width: '21rem',padding: '25px'}}>
                <GridCell>
                  <div style={{padding: '0 1rem 1rem 1rem'}}>
                    <img src={centaLogo} alt="logo" />
                  </div>
                    {tokenErrorMsg}
                    {inactiveErrorMsg}
                    <StatusMessage 
                      error_msg = {this.state.errorMsg}
                    />     
                </GridCell>
              </Card>
            </form>
          </GridCell>
          <GridCell span="4" align="middle"></GridCell>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenLogin)




// WEBPACK FOOTER //
// ./src/views/TokenLogin.jsx